import { observer } from 'mobx-react-lite';
import { useHosterAppModel } from '../models/HosterAppModel';
import { StrokeText, fontSizes, growShrink, padding } from '@toilet-paper-games/ui';
import { useEffect, useState } from 'react';

// enum HosterLobbyState {
//   WAITING_FOR_PLAYERS,
//   WAITING_FOR_GAME_SELECTION,
//   READY_TO_START,
// }

// const HosterLobbyStateMessages: Record<HosterLobbyState, string> = {
//     [HosterLobbyState.WAITING_FOR_PLAYERS]: 'Waiting for players to join...',
//     [HosterLobbyState.WAITING_FOR_GAME_SELECTION]: 'Select a game to start',
//     [HosterLobbyState.READY_TO_START]: 'Press play to begin',
// }

export const HosterStatusMessage = observer(
  (props: React.HTMLAttributes<HTMLDivElement>) => {
    const [statusMessage, setStatusMessage] = useState<string>(
      'Waiting for players to join...',
    );
    const appStore = useHosterAppModel();
    useEffect(() => {
      if (appStore.networkHandler.userManager.users.length <= 1) {
        setStatusMessage('Scan, or enter the code on your device!');
      } else {
        setStatusMessage('Waiting for the host to pick a game...');
      }
    }, [appStore.networkHandler.userManager.users.length, appStore.selectedGame]);

    return (
      <div
        {...props}
        css={[
          growShrink('3s'),
          { fontSize: `min(${fontSizes.lg}, 2.5vw)`, textAlign: 'center' },
        ]}
      >
        <StrokeText>{statusMessage}</StrokeText>
      </div>
    );
  },
);
